import { render, staticRenderFns } from "./StrBirimProses.vue?vue&type=template&id=67ff88b4"
import script from "./StrBirimProses.vue?vue&type=script&lang=js"
export * from "./StrBirimProses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports